// any here to match ag-grid api
import {ValueFormatterParams} from './AgGridTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ValueFormatter = (params: ValueFormatterParams) => any;
